import Foto from "./style";

export default function Imag(props) {
  return (
    <Foto src={props.src} alt="Imagem de perfil do usuário" />
  )
}